import '../../../../../../../assets/css/miniMap.css'
import { Grid, Typography, Box, Avatar, Chip, Paper } from "@mui/material"
import PushPinIcon from '@mui/icons-material/PushPin';
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { useGeolocalizacaoService, useProjetosService } from "../../../../../../../../use-cases/geo-veles";
import { Circle, MapContainer, TileLayer, useMap } from "react-leaflet";
import { theme } from "../../../../../../../styles";
import L, { Icon } from "leaflet";
import { Marker } from 'react-leaflet';
import markerIcon from '../../../../../../../../assets/img/marker-icon.png'
import { useEffect, useRef, useState } from "react";
import { getZoomLevel } from '../../../../../../../../utils';

export const PreviaFiltroGeolocalizacao = () => {
  // State
  const { projetos } = useAppSelector((state) => state)
  // useState
  const [latLon, setLatLon] = useState<[number, number] | null>(null)
  const circleRef = useRef<any>(null);
  const markerRef = useRef<any>(null);
  // Hook
  const { resetGeolocalizacaoFilter } = useProjetosService()
  const { setResetSelectedGeolocalizacao } = useGeolocalizacaoService()
  // useEffect
  useEffect(() => {
    if (projetos.filtrosSelecionados) {
      if (projetos.filtrosSelecionados.geolocalizacao) {
        setLatLon([
          projetos.filtrosSelecionados.geolocalizacao.data.lat,
          projetos.filtrosSelecionados.geolocalizacao.data.lon
        ])
      }
    }
  }, [projetos.filtrosSelecionados])
  
  const pinIcon = L.icon({
    iconUrl: markerIcon,
    iconSize: [40, 40],
    iconAnchor: [20, 40]
  });

  const ResetCenterView = (props: any) => {
    const latLon = props.latLon
    const map = useMap()
    const isInitialMount = useRef(true)

    map.pm.setLang('pt_br', {
      actions: {
        finish: 'Salvar alterações',
        cancel: 'Cancelar'
      },
      buttonTitles: {
        editButton: 'Editar'
      },
      measurements: {
        area: 'Área',
        coordinates: 'Coordenadas',
        height: 'Altura',
        perimeter: 'Perímetro',
        radius: 'Raio',
        width: 'Comprimento'
      }
    })

    map.pm.addControls({
      position: 'topright',
      drawCircleMarker: false,
      rotateMode: false,
      customControls: true,
      cutPolygon: false,
      dragMode: false,
      drawCircle: false,
      drawControls: false,
      drawMarker: false,
      drawPolygon: false,
      drawPolyline: false,
      drawRectangle: false,
      drawText: false,
      removalMode: false,
      snappingOption: false,
      editControls: false,
      editMode: false
    })

    map.pm.setGlobalOptions({
      snappable: false,
      markerEditable: false,
      minRadiusCircle: 1000,
      resizableCircle: false,
      pathOptions: {
        color: theme.palette.primary.main
      },
      allowSelfIntersection: false
    })

    map.pm.disableDraw('Polygon');
    map.pm.disableGlobalEditMode();

    useEffect(() => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
      } else {
        if (projetos.filtrosSelecionados?.geolocalizacao) {
          if (latLon) {
            if (circleRef.current) {
              circleRef.current.remove();
            }
            if (markerRef.current) {
              markerRef.current.remove();
            }

            const circle = L.circle(
              latLon,
              {
                pmIgnore: false,
                radius: projetos.filtrosSelecionados.geolocalizacao.radius,
                color: theme.palette.primary.main
              }
            )

            circle.addTo(map)
            circleRef.current = circle;

            const marker = L.marker(
              latLon,
              {
                pmIgnore: false,
                icon: new Icon({
                  iconUrl: markerIcon,
                  iconSize: [40, 40],
                  iconAnchor: [20, 40]
                }),
                draggable: false
              }
            )

            marker.addTo(map)
            markerRef.current = marker;

            circle.on('click', (e) => {
              const divideNumber = (e.target._mRadius / 1000)
              const roundNumber = Math.round(divideNumber)

              const multiplyNumber = (roundNumber * 1000)

              circle.bindPopup(
                `<h2><strong>Raio:</strong> ${(multiplyNumber / 1000).toLocaleString('pt-BR')} km </h2>`
              ).openPopup()
            })

            map.flyTo(
              [projetos.filtrosSelecionados.geolocalizacao.data.lat, projetos.filtrosSelecionados.geolocalizacao.data.lon],
              getZoomLevel(projetos.filtrosSelecionados.geolocalizacao.radius),
              {
                duration: 1
              }
            )
          }
        }
      }
    }, [latLon, map])

    return null
  }

  return (
    <>
      {
        projetos.filtrosSelecionados?.geolocalizacao &&
        <Paper elevation={2} sx={{ my: 2, p: 2 }} >
          <Box my={3}>
            <Typography color="primary" fontWeight={"bold"} textTransform={'uppercase'}>
              Geolocalização selecionada:
            </Typography>
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={12}
              marginBottom={2}
            >
              <Chip
                sx={{
                  height: 'auto',
                  '& .MuiChip-label': {
                    transition: '0.1s all',
                    cursor: 'default',
                    display: 'block',
                    whiteSpace: 'normal',
                    padding: '10px 15px',
                    fontWeight: 'bold'
                  },
                }}
                color="primary"
                onDelete={() => {
                  resetGeolocalizacaoFilter()
                  setResetSelectedGeolocalizacao()
                }}
                avatar={
                  <Avatar>
                    <PushPinIcon
                      sx={{
                        "&": {
                          transition: '0.1s all'
                        },
                        "&:hover": {
                          color: "secondary.main",
                          cursor: 'default'
                        }
                      }}
                    />
                  </Avatar>
                }
                label={projetos.filtrosSelecionados.geolocalizacao.data.name ?? ''}
              />
            </Grid>
            <Grid item xs={12}>
              <MapContainer
                center={[projetos.filtrosSelecionados.geolocalizacao.data.lat, projetos.filtrosSelecionados.geolocalizacao.data.lon]}
                zoom={15}
                minZoom={4}
                className="mapContainer"
              >
                <TileLayer
                  attribution=''
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Circle
                  center={[projetos.filtrosSelecionados.geolocalizacao.data.lat, projetos.filtrosSelecionados.geolocalizacao.data.lon]}
                  radius={(projetos.filtrosSelecionados.geolocalizacao.radius * 1000)}
                  pmIgnore={true}
                  pathOptions={{ color: theme.palette.primary.main }}
                />
                <Marker
                  position={[projetos.filtrosSelecionados.geolocalizacao.data.lat, projetos.filtrosSelecionados.geolocalizacao.data.lon]}
                  icon={pinIcon}
                />
                <ResetCenterView latLon={latLon} />
              </MapContainer>
            </Grid>
          </Grid>
        </Paper>
      }
    </>
  )
}